import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useState } from "react";
import { X } from "lucide-react";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import CanonicalTag from "@/components/CanonicalTag";

const RanchStyleADUDesignFremont = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Ranch Style ADU Design & Construction in Fremont",
    "description": "Design classic Ranch Style ADUs in Fremont with single-story layouts, open floor plans, and horizontal emphasis.",
    "publisher": {
      "@type": "Organization",
      "name": "UDA ADU"
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/ranch-style-adu-design-fremont" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <Navigation />

      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative w-full max-w-2xl h-[70vh] bg-white rounded-lg overflow-hidden shadow-xl">
            <button onClick={closeCalendlyModal} className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors">
              <X className="h-6 w-6 text-gray-600" />
            </button>
            <iframe src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" width="100%" height="100%" frameBorder="0" title="Schedule a meeting" />
          </div>
        </div>
      )}

      <main className="max-w-6xl mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            Ranch Style ADU Design & Construction in Fremont
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Design classic Ranch Style ADUs in Fremont with single-story layouts, open floor plans, and horizontal emphasis.
          </p>
        </div>

        <div className="text-center">
          <Button onClick={openCalendlyModal} size="lg" className="mr-4">
            Schedule Consultation
          </Button>
          <Button asChild variant="outline" size="lg" className="text-white border-white hover:bg-white hover:text-black">
            <Link to="/adu-calculator">Get Cost Estimate</Link>
          </Button>
        </div>
      </main>

      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default RanchStyleADUDesignFremont;